import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'jobSearch'
})
export class JobSearchPipe implements PipeTransform {

  public transform(values: any[], filter: string): any[] {
    
    if (!values || !values.length) return [];
    if (!filter) return values;
    
    return values.filter(v => {
      if(!v.city){v.city='';}
      if(!v.jobNumber){v.jobNumber='';}
      if(!v.address1){v.address1='';}
      
      const JobNumber = v.jobNumber.toString().toLowerCase().includes(filter.toString().toLowerCase())    
      const jobName =  v.address1.toString().toLowerCase().includes(filter.toString().toLowerCase())      
      const city =  v.city.toString().toLowerCase().includes(filter.toString().toLowerCase()) 

      let retval = ( JobNumber + jobName + city);  
      // if(retval){
      //   console.log('Found:', v);
      // }
    
      return     retval;
    }
      );
  }

}
